module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_vm._v("Contents")])]), _vm._v(" "), _c('table', {
    attrs: {
      "cellpadding": "8",
      "cellspacing": "3",
      "width": "150%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONE")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_c('i', [_vm._v("“Outremer”")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter02"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TWO")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter02"
    }
  }, [_c('i', [_vm._v("Macabru")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THREE")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Sutcliffe, The Venetian Documents")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FOUR")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Life with Toby")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FIVE")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Dinner at Quartila’s")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10081a2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents1.vue
// module id = 75
// module chunks = 0